import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { reducer as modal } from 'redux-modal';
import LoaderReducer from './LoaderReducer';
import settingsReducer from './SettingsReducer';
import { SessionApi, AdminApi, PublisherApi, AdvertiserApi, ExternalApi, SspApi } from '../api';

export default combineReducers({
  ...SessionApi.reducers,
  modal,
  routing: routerReducer,
  form: formReducer,
  toastr: toastrReducer,
  loader: LoaderReducer,
  admin: combineReducers(AdminApi.reducers),
  ssp: combineReducers(SspApi.reducers),
  publisher: combineReducers(PublisherApi.reducers),
  advertiser: combineReducers(AdvertiserApi.reducers),
  external: combineReducers(ExternalApi.reducers),
  settings: settingsReducer
});
